import EditorRoutes from 'foundation/EditorRoutes';
import {RouteBundle} from 'routing/RouteConstants';

export const ParameterLibraryRoutes: RouteBundle = {
  domain: 'parameter-library',
  routes: [
    {
      urlPattern: 'library-parameter-definitions/listing',
      handler: EditorRoutes.parameterLibraryListing.bind(EditorRoutes),
    },
  ],
};
